// Analytics must never block the filter change or click it reports.
const safely = (track) => (...args) => {
  try {
    track(...args)
  } catch (error) {
    // Dropped on purpose: a missing data layer, store or cart must not surface to the viewer.
  }
}

export default safely
